import { advertiserCoverUrl } from './advertiserBranding';

export const MAX_GALLERY = 4;
export const MAX_TEAM = 4;
export const MAX_STRENGTHS = 3;
const text = (value, max = 200) => (typeof value === 'string' ? value.trim().slice(0, max) : '');
const list = value => (Array.isArray(value) ? value : []);
const object = value => (value && typeof value === 'object' && !Array.isArray(value) ? value : {});
export const safeWebsite = value => {
  const input = text(value, 500);
  if (!input || /[\s\\]/.test(input)) return '';
  try {
    const url = new URL(/^[a-z][a-z\d+.-]*:/i.test(input) ? input : `https://${input}`);
    return ['https:', 'http:'].includes(url.protocol) &&
      !url.username &&
      !url.password &&
      url.hostname.includes('.')
      ? url.href
      : '';
  } catch (_) {
    return '';
  }
};
export const safeEmail = value => {
  const email = text(value, 254);
  return /^[^\s@<>?&#]+@[^\s@<>?&#]+\.[^\s@<>?&#]+$/.test(email) ? email : '';
};
export const safePhone = value => {
  const phone = text(value, 40);
  return /^[+\d\s().-]+$/.test(phone) && phone.replace(/\D/g, '').length >= 6 ? phone : '';
};
const imageId = value => (advertiserCoverUrl(value) ? value : null);

// Read public content only. Explicit empty values override older public fields.
export const getAdvertiserProfile = (publicData = {}) => {
  publicData = object(publicData);
  const saved = object(publicData.advertiserProfile);
  const value = (key, legacyKey = key) =>
    Object.prototype.hasOwnProperty.call(saved, key) ? saved[key] : publicData[legacyKey];
  return {
    version: 1,
    tagline: text(value('tagline'), 160),
    aboutTitle: text(value('aboutTitle'), 100),
    portfolioTitle: text(value('portfolioTitle'), 100),
    teamTitle: text(value('teamTitle'), 100),
    contactTitle: text(value('contactTitle'), 100),
    contactName: text(value('contactName'), 100),
    publicEmail: safeEmail(value('publicEmail')),
    publicPhone: safePhone(value('publicPhone')),
    websiteLink: safeWebsite(value('websiteLink')),
    publicAddress: text(value('publicAddress'), 250),
    openingHours: text(value('openingHours'), 350),
    linkedin: safeWebsite(value('linkedin')),
    instagram: safeWebsite(value('instagram')),
    facebook: safeWebsite(value('facebook')),
    yearCreated: /^\d{4}$/.test(String(value('yearCreated') || ''))
      ? String(value('yearCreated'))
      : '',
    coverPosition: ['top', 'center', 'bottom'].includes(value('coverPosition'))
      ? value('coverPosition')
      : 'center',
    showMap: value('showMap') !== false,
    showGallery: value('showGallery') !== false,
    showTeam: value('showTeam') !== false,
    gallery: list(value('gallery'))
      .slice(0, MAX_GALLERY)
      .map(photo => ({ id: imageId(photo?.id), caption: text(photo?.caption, 120) }))
      .filter(photo => photo.id),
    strengths: list(value('strengths', 'values'))
      .slice(0, MAX_STRENGTHS)
      .map(item => ({
        title: text(item?.title, 70),
        description: text(item?.description || item?.desc, 300),
      })),
    team: list(value('team'))
      .slice(0, MAX_TEAM)
      .map(member => ({
        name: text(member?.name, 100),
        role: text(member?.role || member?.jobTitle, 100),
        bio: text(member?.bio, 400),
        email: safeEmail(member?.email),
        phone: safePhone(member?.phone),
        linkedin: safeWebsite(member?.linkedin),
        photoId: imageId(member?.photoId),
        avatarUrl: safeWebsite(member?.avatarUrl),
        listingIds: list(member?.listingIds)
          .filter(id => typeof id === 'string')
          .slice(0, 200),
      })),
  };
};

export const serializeAdvertiserProfile = values =>
  getAdvertiserProfile({ advertiserProfile: values });
export const optionalEmail = value =>
  !value || safeEmail(value) ? undefined : 'Saisissez une adresse e-mail valide.';
export const optionalPhone = value =>
  !value || safePhone(value) ? undefined : 'Saisissez un numéro de téléphone valide.';
export const optionalWebsite = value =>
  !value || safeWebsite(value) ? undefined : 'Saisissez une adresse de site valide (https://…).';
